import { Row, Col, Tooltip, Divider } from 'antd';
import NodeJS from '../icons/nodejs.svg';
import Php from '../icons/php.svg';
import ReactJS from '../icons/react.svg';
import MongoDB from '../icons/mongodb.svg';
import MySQL from '../icons/mysql.svg';
import Electron from '../icons/electron.svg';
import jQuery from '../icons/jquery.svg';
import MQL from '../icons/metatrader.svg';

import './aboutme.scss';

const AboutME = () => {

    const getImage = i => {
        switch(i){
            case 'react': return ReactJS;
            case 'php': return Php;
            case 'nodejs': return NodeJS;
            case 'mongodb': return MongoDB;
            case 'electron': return Electron;
            case 'mysql': return MySQL;
            case 'jquery': return jQuery;
            case 'mql': return MQL;
            default: return null; 
        }
    }


    const generateIcons = () => {
        const icons=['react','nodejs','php', 'jquery', 'electron', 'mongodb', 'mysql', 'mql']
        const Span = Math.ceil(24/16);
        return <Row justify="center" gutter={16}>
            {icons.map(i => <Col key={i} md={Span+1} lg={Span} xl={Span} xxl={Span} sm={Span+1} xs={Span+4}><Tooltip title={i.charAt(0).toUpperCase()+i.slice(1)} color="yellow"><img alt={i} src={getImage(i)} /></Tooltip></Col>)}
        </Row>;
    }

    return (
        <Row style={{ position: 'relative', textAlign: 'center' }} gutter={16} className="ahmedrhuma-resume-container">
            <h1>ABOUT <span>ME</span></h1>
            <span className='title-bg'>RESUME</span>
            <Col className="resume-rows" md={24} lg={12} xl={12} xxl={12} sm={24} xs={24} style={{ textAlign: 'left' }}>
                <h2>PERSONAL INFO</h2>
                <Row gutter={16}>
                    <Col span={12}>
                        <p><span>First Name: </span> Ahmed</p>
                        <p><span>Last Name: </span>Rhuma</p>
                        <p><span>Age: </span>{(new Date()).getUTCFullYear() - 1994} Years</p>
                        <p><span>Nationality: </span>Libyan</p>
                    </Col>
                    <Col span={12}>
                        <p><span>Address: </span> Tripoli, Libya</p>
                        <p><span>Email: </span>ahmed@rhuma.net</p>
                        <p><span>Languages: </span>Arabic, English, Turkish (A2)</p>
                    </Col>
                </Row>
            </Col>
            <Col md={24} lg={12} xl={12} xxl={12} sm={24} xs={24} className="blocks-resume">
                <Row gutter={16}>
                    <Col sm={24} xs={24} md={12} lg={12} xl={12} xxl={12}>
                        <div>
                            <h3>10</h3>
                            <p>
                            Years of <span>Experience</span>
                            </p>
                        </div>
                    </Col>
                    <Col sm={24} xs={24} md={12} lg={12} xl={12} xxl={12}>
                        <div>
                            <h3>40</h3>
                            <p>
                            Completed <span>Projects</span>
                            </p>
                        </div>
                    </Col>
                </Row>
            </Col>
            <Col className='icons-container' span={24}>
                <h3>I WORK WITH</h3>
                {generateIcons()}
            </Col>
            <Divider />
            <Row style={{ position: 'relative', width: '100%', textAlign: 'center' }} gutter={16} className="ahmedrhuma-resume-container">
                <h1>Education</h1>
                <span className='title-bg'>RESUME</span>
                <div className="resume">
                    <h1>Bachelor of Science in Software Engineering</h1>
                    <h2><a href="https://uot.edu.ly" target="_blank">University of Tripoli</a>, Faculty of Information Technology <span>2017</span></h2>
                </div>
            </Row>
            <Divider />
            <Row style={{ position: 'relative', width: '100%', textAlign: 'center' }} gutter={16} className="ahmedrhuma-resume-container">
                <h1>Professional <span>Experience</span></h1>
                <span className='title-bg'>RESUME</span>
                <div className="resume">
                    <h1>Arab Investment Islamic Bank (AIIB)</h1>
                    <h2>Head of Software & Development  Department <span>2024 - present</span></h2>
                    <ul>
                        <li>Responsible for designing the infrastructure of the main and DR data centers.</li>
                        <li>Responsible for the management of all servers, backups and operating systems.</li>
                        <li>Project manager for the installation of the ERP system (Odoo).</li>
                        <li>Chairman of the committee for receiving and reviewing the bank's technical equipment.</li>
                        <li>Team member responsible for the installation and configuration of ATMs.</li>
                        <li>SWIFT Alliance Access Administrator.</li>
                        <li>Hypervisor Administrator (ESXI, OLVM and vCenter).</li>
                        <li>Developed an Odoo application using Python, Javascript to track attendance and apply Libyan labor law.</li>
                        <li>Developed an Odoo module using Python to generate HR reports required by Libyan law.</li>
                        <li>Created a backup strategy for servers and databases.</li>
                        <li>Responsible for ensuring the integrity of the local RTGS and ACH systems.</li>
                        <li>Responsible for installing and configuring the Endpoint Central device management system for the organization.</li>
                        <li>Microsoft 365 Administrator.</li>
                        <li>Domain Controller & DNS Server & DHCP Server Administrator.</li>
                        <li>Responsible for the preparation of Domain Controller GPOs.</li>

                    </ul>
                    <h1>Tadhamun Bank (TAB)</h1>
                    <h2>Head of Software & Application  Department <span>2023 - 2024</span></h2>
                    <ul>
                        <li>Responsible of OLVM hypervisors.</li>
                        <li>Oracle Banking Digital Experience (OBDX) project team member and system administrator.</li>
                        <li>Developed a software that provides SMS Banking and WhatsApp Banking.</li>
                        <li>Developed a system using React.js, Node.js, and MongoDB to integrate with the CBL’s FCMS system and integrate it with the FlexCube banking system.</li>
                    </ul>
                    <h1>Nahor LTD</h1>
                    <h2>Co-Founder & CTO <span>2019 - 2023</span></h2>
                    <ul>
                        <li>Developed Huemix System, a large-scale enterprise system for managing Libyan health insurance companies, using NodeJS, MongoDB and ReactJS with SocketIO and RESTful API.</li>
                    </ul>
                    <h1>Vitalis Tunis</h1>
                    <h2>IT Consultant <span>2018 - 2019</span></h2>
                    <ul>
                        <li>Responsible for installing and preparing infrastructure for the AML & KYC systems.</li>
                        <li>Developed middleware to integrate Siron KYC with Temenos (T24) Core banking for Albaraka Tunis Bank.</li>
                        <li>Developed middleware to integrate Siron KYC with Finastra Core Banking System in QNB Tunis Bank.</li>
                    </ul>
                    <h1>Aldaleel Alraqmee</h1>
                    <h2>Oracle Database Administrator <span>2016 - 2018</span></h2>
                    <ul>
                        <li>Oracle database administrators for the company's customers.</li>
                    </ul>
                </div>
            </Row>
            <Divider />
            <Row style={{ position: 'relative', width: '100%', textAlign: 'center' }} gutter={16} className="ahmedrhuma-resume-container">
                <h1>Skills & <span>Achievements</span></h1>
                <span className='title-bg'>RESUME</span>
                <div className="resume">
                    <ul>
                        <li>Ability to manage a team and organize work using project and task management tools</li>
                        <li>Proficient developer of Node.js and React.js</li>
                        <li>Developed software using Java and Python, and wrote Bash scripts to run on Linux and PowerShell.</li>
                        <li>Experience working on large projects on RDBMS such as Oracle, MySQL and No-SQL databases such as MongoDB.</li>
                        <li>Experience in managing and configuring servers and infrastructure such as domain controller, NTP, DNS, DHCP, and enterprise computer management systems.</li>
                        <li>Experience working with cloud databases and Amazon Cloud environment AWS.</li>
                        <li>I have done integration projects with WhatsApp, prepaid card purchasing systems and banking systems.</li>
                        <li>Developed an SMS banking system through integration with Libyana, Al-Madar, and intermediary service providers such as Al-Masafa via the SMPP protocol.</li>
                        <li>Obtained the Oracle Certified Database Administrator certification in 2017 on version 11g.</li>
                        <li>I built a complete system to manage the FCMS system through integration with the Central Bank of Libya and the core banking system.</li>
                        <li>Built Telegram bot and WhatsApp bot in different fields, banking and non-banking fields.</li>
                        <li>I built Odoo support systems using Python and JavaScript to be able to work efficiently in an enterprise environment.</li>
                        <li>Resolved a problem in one of TAB Bank's servers that had existed for many months and was being followed up by Oracle and the company responsible for supplying the equipment.</li>
                        <li>Built various applications for non-banking customers while I was student and working as freelancer</li>
                    </ul>
                </div>
                
            </Row>
        </Row>
    )
}

export default AboutME;